import Vue from 'vue'
import router from '@/router';
import http from './modules/http_services'
import contests from './modules/mod_contests'
import voting from './modules/mod_voting'
import nominations from './modules/mod_nominations'
import lists from './modules/mod_lists'
import session from './modules/mod_session'
import nav from './modules/mod_navigation'
import categories from './modules/mod_categories'
import instances from './modules/mod_instances'
import manipulation_helpers from './modules/mod_manipulation_helpers'
import storage from './modules/mod_storage'

export default {
	debug: true,
	state: {
		clientid: 'FA721ACE33381B9F3B1B881B9B24370D'
	},

	get_current_clientid: function() {
		return this.state.clientid;
	},

	goto_path: function(path_name, param) {
		let push_path = path_name;

		// APPEND TRAILING SLASH
		if(push_path.slice(-1) != '/') {
			push_path += '/';
		}

		// IF PARAM SET, APPEND IT
		if(param) {
			push_path += param + '/';
		}

		// console.log('push_path: ', push_path);

		router.push({
			path: push_path,
		})
    },

	nominations,
	contests,
	voting,
	lists,
	session,
	nav,
	categories,
	instances,
	manipulation_helpers,
	storage
}


// WEBPACK FOOTER //
// ./src/store/store.js